<app-nav-bar></app-nav-bar>
<router-outlet></router-outlet>
<app-footer></app-footer>
<app-bottom-tab-bar></app-bottom-tab-bar>